import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"16px"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_5 = { class: "card flex flex-column md:flex-row gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_7 = { class: "stream" }
const _hoisted_8 = { class: "p-field p-col p-col-6 p-md-6 p-lg-3" }
const _hoisted_9 = { class: "p-field p-col p-col-6 p-md-6 p-lg-3" }
const _hoisted_10 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"16px"}
}
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"16px"}
}
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_StreamBarcodeReader = _resolveComponent("StreamBarcodeReader")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, { header: "Tra cứu thông tin CLS của bệnh nhân" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      useGrouping: false,
                      id: "name",
                      placeholder: "Nhập mã bệnh nhân...",
                      modelValue: $setup.maYTe,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maYTe) = $event)),
                      style: {"text-align":"center","font-size":"16px"},
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.loadListCls()), ["enter"]))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Button, {
                      label: "Xóa",
                      icon: "pi pi-delete-left",
                      severity: "danger",
                      iconPos: "left",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteData())),
                      style: {"font-size":"16px"}
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            ($setup.openCamera)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_StreamBarcodeReader, {
                      zoom: 3,
                      autofocus: true,
                      onDecode: $setup.onDecode,
                      onLoaded: $setup.onLoaded
                    }, null, 8, ["onDecode", "onLoaded"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Quét mã bệnh nhân", -1)),
              _createVNode(_component_Button, {
                label: "Quét mã",
                icon: "pi pi-barcode",
                severity: "warning",
                iconPos: "left",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.scanBarcode())),
                style: {"font-size":"16px"}
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Tra cứu", -1)),
              _createVNode(_component_Button, {
                label: "Tìm",
                icon: "pi pi-search",
                iconPos: "left",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.loadListCls())),
                style: {"font-size":"16px"}
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      ($setup.listCLS.length > 0)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            header: "Thông tin bệnh nhân"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)),
                  _createVNode(_component_InputText, {
                    id: "maYTe",
                    type: "text",
                    modelValue: $setup.listCLS[0].mayte,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.listCLS[0].mayte) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Họ và tên", -1)),
                  _createVNode(_component_InputText, {
                    id: "hoVaTen",
                    type: "text",
                    modelValue: $setup.listCLS[0].tenbenhnhan,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.listCLS[0].tenbenhnhan) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Số điện thoại", -1)),
                  _createVNode(_component_InputText, {
                    id: "soDienThoai",
                    type: "text",
                    modelValue: $setup.listCLS[0].sodienthoai,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.listCLS[0].sodienthoai) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Ngày sinh", -1)),
                  _createVNode(_component_InputText, {
                    id: "ngaySinh",
                    modelValue: $setup.ngaySinh,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.ngaySinh) = $event)),
                    type: "text",
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      ($setup.listCLS.length > 0)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            header: "Chọn thời gian trả kết quả cho bệnh nhân"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Chọn thời gian", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "permission",
                    modelValue: $setup.result.minute,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.result.minute) = $event)),
                    options: $setup.listTime,
                    optionLabel: "label",
                    optionValue: "value",
                    placeholder: "Vui lòng chọn thời gian hoàn thành xét nghiệm ..."
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Thực hiện", -1)),
                  _createVNode(_component_Button, {
                    label: "Thực hiện",
                    icon: "pi pi-calendar-clock",
                    severity: "danger",
                    iconPos: "left",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.createResultNotification())),
                    style: {"font-size":"16px"}
                  })
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}